import { Routes } from "@angular/router";
import { LoginComponent } from "./modules/login/login.component";
import { NotFoundComponent } from "./modules/shared/not-found/not-found.component";
import { UnauthorizedComponent } from "./modules/shared/unauthorized/unauthorized.component";
import { AuthorizationGuard } from "./modules/core/guards/authorization.guard";
import { permissionType } from "./models/enums";

export const APP_ROUTES: Routes = [
  {
    path: ":guid/home",
    canActivate: [AuthorizationGuard],
    data: {
      auth: [permissionType.Authenticated],
    },
    loadChildren: () => import("./modules/home/home.routes").then((m) => m.HOME_ROUTES),
  },
  {
    path: ":guid/my-work-orders",
    canActivate: [AuthorizationGuard],
    data: {
      auth: [permissionType.Authenticated],
    },
    loadChildren: () => import("./modules/work-orders/work-orders.routes").then((m) => m.WORK_ORDERS_ROUTES),
  },
  {
    path: ":guid/admin",
    canActivate: [AuthorizationGuard],
    data: {
      auth: [permissionType.Authenticated],
    },
    loadChildren: () => import("./modules/admin/admin.routes").then((m) => m.ADMIN_ROUTES),
  },
  {
    path: ":guid/customer-accounts",
    canActivate: [AuthorizationGuard],
    data: {
      auth: [permissionType.Authenticated],
    },
    loadChildren: () =>
      import("./modules/customer-account/customer-account.routes").then((m) => m.CUSTOMER_ACCOUNT_ROUTES),
  },
  {
    path: ":guid/campus/:campusId",
    canActivate: [AuthorizationGuard],
    data: {
      auth: [permissionType.Authenticated],
    },
    loadChildren: () => import("./modules/campus/campus.routes").then((m) => m.CAMPUS_ROUTES),
  },
  {
    path: ":guid/facility/:facilityId",
    canActivate: [AuthorizationGuard],
    data: {
      auth: [permissionType.Authenticated],
    },
    loadChildren: () => import("./modules/facilities/facility.routes").then((m) => m.FACILITY_ROUTES),
  },
  {
    path: ":guid/switch-accounts",
    canActivate: [AuthorizationGuard],
    data: {
      auth: [permissionType.Authenticated],
    },
    loadChildren: () =>
      import("./modules/switch-accounts/switch-accounts.routes").then((m) => m.SWITCH_ACCOUNTS_ROUTES),
  },
  {
    path: ":guid/form",
    canActivate: [AuthorizationGuard],
    data: {
      auth: [permissionType.Authenticated],
      reuse: false,
    },
    loadChildren: () => import("./modules/forms/form.routes").then((m) => m.FORM_ROUTES),
  },
  {
    path: "assets",
    loadChildren: () => import("./modules/assets/asset.routes").then((m) => m.ASSET_ROUTES),
  },
  { path: "login", component: LoginComponent },
  { path: "unauthorized", component: UnauthorizedComponent },
  { path: "notfound", component: NotFoundComponent },
  { path: "**", redirectTo: "/notfound" },
];
